//https://help.iteratehq.com/faq/website-surveys/identifying-users
export const initIterate = (employee: $TSFixMe, company: $TSFixMe) => {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'Iterate' does not exist on type 'Window ... Remove this comment to see the full error message
  if (employee && window.Iterate) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'Iterate' does not exist on type 'Window ... Remove this comment to see the full error message
    window.Iterate('identify', {
      email: employee.email,
      user_id: employee.id,
      first_name: employee.first_name,
      last_name: employee.last_name,
      full_name: employee.full_name,
      company: company.id,
      location: employee.settings.location_id,
    });
  }
};
